import { render } from "./content-doorways.vue?vue&type=template&id=7ccffa3f"
import script from "./content-doorways.vue?vue&type=script&lang=js"
export * from "./content-doorways.vue?vue&type=script&lang=js"

import "./content-doorways.vue?vue&type=style&index=0&id=7ccffa3f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__